import { reducerWithInitialState } from 'typescript-fsa-reducers/dist'
import * as actions from './actions'
import * as apiActions from '../api/actions'
import { cloneMap } from '../root/functions'
import { MediaItemsStoreState } from './types'
export interface StoreState {
	readonly mediaItems: MediaItemsStoreState
}

const INITIAL_STATE: StoreState = {
	mediaItems: new Map(),
}

export const reducer = reducerWithInitialState(INITIAL_STATE)
	.case(
		apiActions.fetchMediaItem.started,
		(state, payload): StoreState => {
			if (payload.isPreCaching) {
				return state
			}

			const updatedMediaItems = cloneMap(state.mediaItems)
			updatedMediaItems.set(payload.itemId, { loading: true })

			return {
				...state,
				mediaItems: updatedMediaItems,
			}
		},
	)
	.case(
		apiActions.fetchMediaItem.done,
		(state, payload): StoreState => {
			if (payload.params.isPreCaching) {
				return state
			}

			const updatedMediaItems = cloneMap(state.mediaItems)
			updatedMediaItems.set(payload.params.itemId, {
				item: payload.result,
				version: payload.params.itemVersion,
				loading: false,
			})

			return {
				...state,
				mediaItems: updatedMediaItems,
			}
		},
	)
	.case(
		apiActions.fetchMediaItem.failed,
		(state, payload): StoreState => {
			if (payload.params.isPreCaching) {
				return state
			}

			const updatedMediaItems = cloneMap(state.mediaItems)
			updatedMediaItems.set(payload.params.itemId, { error: payload.error, loading: false })

			return {
				...state,
				mediaItems: updatedMediaItems,
			}
		},
	)
	.case(
		actions.loadedMediaItemFromDisk,
		(state, payload): StoreState => {
			const updatedMediaItems = cloneMap(state.mediaItems)
			updatedMediaItems.set(payload.id, { item: payload.mediaItem, version: payload.version, loading: false })

			return {
				...state,
				mediaItems: updatedMediaItems,
			}
		},
	)
